import { confirmAlert } from "react-confirm-alert";
import React from "react";

import "../style.css";

const alertConfirmation = {
    confirmDelete: (onClickFunction, confirmMessage) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="react-confirm-alert-body">
                        <h1>Please confirm</h1>
                        <p>{confirmMessage}</p>
                        <div className="react-confirm-alert-button-group">
                            <button
                                className="btn btn-success"
                                onClick={onClose}
                            >
                                No
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={() => onClickFunction(onClose)}
                            >
                                Yes, Delete it!
                            </button>
                        </div>
                    </div>
                );
            }
        });
    }
};

export default alertConfirmation;



// WEBPACK FOOTER //
// ./src/components/confirmDelete.js